import React from 'react';

import { OxLink } from 'src/components/OxLink';
import { getExternalLinkProps } from 'src/utils/getExternalLinkProps';

type TProps = {
    children: React.ReactNode;
    value?: {
        href?: string;
    };
};

export const OxPortableTextLink = ({ children, value }: TProps): JSX.Element => {
    const externalLinkProps = getExternalLinkProps(value?.href);

    return (
        <OxLink to={value?.href} target={externalLinkProps.target} rel={externalLinkProps.rel}>
            {children}
        </OxLink>
    );
};
